// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import Products from "./filter.js";

document.addEventListener("DOMContentLoaded", () => {
  
  // $('#about_text').on('hidden', function () {
  //   // do something…
  //   alert('aaa');
  // });

  // $('#about_text').on('show', function () {
  //   // do something…
  //   alert('bbb');
  // });

  


  Products.init();
  
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js